module.exports = __webpack_public_path__ + "img/fmwhatsapp.8d50a596.webp";